import { AllowedAction } from '@/data/allowedActions'
import type { PermissionRequirement } from '@/components/IfAnyPermission'

// A role's scope_type → the module the backend's per-scope role endpoints actually check
// for WRITE (編輯 / 設定權限 / 刪除). Mirrors matrix X: org-internal role tables are the
// OWNING provider's sovereignty — sub-units (clinic / supplier / group) don't manage their
// own roles, and sys_admin is read-only on every org scope (no write). The system scope is
// sys_admin's own layer (system_user_role). Keep in sync with:
//   apps/admin-api/src/routes/roles/scopedRoleRoutes.ts  (編輯 U / 刪除 D)
//   apps/admin-api/src/routes/userRolePermission.ts       (設定權限 U)
const ROLE_WRITE_MODULE: Record<string, string> = {
  sys_admin: 'system_user_role',
  provider: 'provider_user_role',
  clinic: 'provider_clinic_management',
  ad_supplier: 'provider_supplier_management',
  clinic_group: 'provider_clinic_group_management',
  ad_supplier_group: 'provider_ad_supplier_group_management',
}

/**
 * Permission a user must hold to WRITE a role of the given scope. Pair with
 * `<IfAnyPermission requireExplicitForAdmin>` so the action menu never shows a write the
 * API would answer with 403 — including sys_admin on org scopes (read-only oversight).
 * Unknown scope falls back to the system module (fail toward the most-trusted layer).
 */
export function roleWritePermission(
  scopeType: string | undefined,
  action: AllowedAction,
): PermissionRequirement[] {
  const moduleName = ROLE_WRITE_MODULE[scopeType ?? ''] ?? 'system_user_role'
  return [{ module: moduleName, action }]
}
